export const recipesDe = {
  title: 'Rezepturen und Stücklisten',
  subtitle: 'Versionierte, revisionssichere Rezepturen und mehrstufige BOMs.',
  empty: 'Keine Rezepturversion entspricht den gewählten Filtern.',
  pagination: 'Seite {{page}} von {{pages}} · {{total}} Versionen',
  help: {
    open: 'Hilfe zu Rezepturen und Stücklisten öffnen',
    list: 'Rezepturen nach Lebenszyklus, Ausgabeartikel, Komponente oder Gültigkeit filtern.',
    header:
      'Nummer und Ausgabeartikel bilden die stabile Rezepturidentität. Inhalte ändern sich ausschließlich über kontrollierte Versionen.',
    translations:
      'Bezeichnungen und Beschreibungen werden für jede unterstützte Sprache getrennt gespeichert.',
    components:
      'Positionen verweisen auf Artikel oder freigegebene Unterrezepturen. Mengen und Kosten werden dezimalgenau verarbeitet.',
    dmsSnapshot:
      'Wähle die geschützten DMS-Originale, die exakt zu diesem Versionssnapshot gehören.',
    history:
      'Freigegebene Versionen bleiben unveränderlich und können in einen neuen Entwurf kopiert werden.',
    impact:
      'Zeigt direkte Elternrezepturen und alle über die vollständige BOM-Hierarchie betroffenen Ausgabeartikel.',
    productUsage:
      'Wähle eine Komponente, um alle Rezepturen und Produkte mit direkter Verwendung anzuzeigen.',
  },
  actions: {
    new: 'Neue Rezeptur / BOM',
    alternatives: 'Alternativen',
    submit: 'Zur Prüfung einreichen',
    review: 'Prüfung abschließen',
    approve: 'Freigeben',
    copy: 'Version kopieren',
    block: 'Sperren',
    archive: 'Archivieren',
    addComponent: 'Position hinzufügen',
    compare: 'Versionen vergleichen',
    addAlternative: 'Alternative hinzufügen',
    reject: 'Ablehnen',
  },
  filters: {
    search: 'Nummer, Rezeptur oder Ausgabeartikel suchen',
    status: 'Lebenszyklusstatus',
    allStatuses: 'Alle Status',
    validOn: 'Gültig am',
    componentSearch: 'Positionen nach Artikel, Rezeptur, Nummer oder Kommentar suchen',
  },
  columns: {
    number: 'Nummer',
    name: 'Bezeichnung',
    output: 'Ausgabeartikel',
    version: 'Version',
    status: 'Status',
    reference: 'Referenzmenge',
    components: 'Positionen',
    cost: 'Materialkosten',
    validity: 'Gültigkeit',
    updated: 'Letzte Änderung',
  },
  statuses: {
    DRAFT: 'Entwurf',
    IN_REVIEW: 'In Prüfung',
    APPROVED: 'Freigegeben',
    BLOCKED: 'Gesperrt',
    ARCHIVED: 'Archiviert',
  },
  componentTypes: {
    MATERIAL: 'Material',
    SUB_RECIPE: 'Unterrezeptur',
    PACKAGING: 'Verpackung',
    BY_PRODUCT: 'Nebenprodukt',
  },
  substitutionStatuses: {
    PROPOSED: 'Vorgeschlagen',
    APPROVED: 'Freigegeben',
    REJECTED: 'Abgelehnt',
    ARCHIVED: 'Archiviert',
  },
  editor: {
    newTitle: 'Rezeptur / BOM anlegen',
    newDescription: 'Stabile Identität und erste bearbeitbare Version anlegen.',
    versionDescription: 'Kontrollierte Version v{{version}}',
    reorder: 'Position umsortieren',
  },
  fields: {
    number: 'Rezeptur-/BOM-Nummer',
    outputProduct: 'Ausgabeartikel',
    name: 'Bezeichnung',
    baseQuantity: 'Referenzmenge',
    baseUnit: 'Basiseinheit',
    validFrom: 'Gültig ab',
    validTo: 'Gültig bis',
    currency: 'Kostenwährung',
    comments: 'Interne Kommentare',
    localizedName: 'Sprachabhängige Bezeichnung',
    description: 'Beschreibung',
    position: 'Position',
    type: 'Positionstyp',
    component: 'Komponente',
    quantity: 'Menge',
    unit: 'Einheit',
    percentage: 'Anteil %',
    loss: 'Verlust %',
    declarationRelevant: 'Deklarationsrelevant',
    alternatives: 'Alternativen',
    comment: 'Kommentar',
    selectSubRecipe: 'Freigegebene Unterrezeptur wählen',
    selectProduct: 'Artikel wählen',
    alternativeProduct: 'Alternativartikel',
    alternativeRecipe: 'Alternative Unterrezeptur',
    factor: 'Substitutionsfaktor',
    rationale: 'Technische Begründung',
    reason: 'Begründung und Entscheidungsvermerk',
  },
  sections: {
    header: 'Rezepturkopf',
    translations: 'Sprachen',
    components: 'Komponenten und Unterrezepturen',
    snapshotDocuments: 'Dokumentensnapshot der Version',
    history: 'Versionshistorie',
    whereUsed: 'Elternrezepturen und betroffene Produkte',
    affectedProducts: 'Alle betroffenen Produkte über sämtliche BOM-Stufen',
    productUsage: 'Verwendung der gewählten Komponente',
    documents: 'DMS-Akte der Rezeptur',
  },
  summary: {
    quantities: 'Positionssummen je Einheit',
    percentage: 'Summe gepflegter Anteile',
    cost: 'Berechnete Materialkosten',
  },
  warnings: {
    UNIT_NOT_SUMMABLE:
      'Position {{position}} kann nicht in die Basiseinheit {{unit}} umgerechnet werden.',
    COMPONENT_ARCHIVED: 'Der Artikel in Position {{position}} ist archiviert.',
    SUB_RECIPE_NOT_APPROVED: 'Die Unterrezeptur in Position {{position}} ist nicht freigegeben.',
    PERCENTAGE_TOTAL_NOT_100: 'Die gepflegten Anteile ergeben {{percentage}} % statt 100 %.',
    INPUT_OUTPUT_DEVIATION:
      'Umrechenbare Eingänge ({{input}} {{unit}}) weichen von der Referenzausgabe ({{output}} {{unit}}) ab.',
  },
  states: {
    invalidDecimal: 'Ungültige Dezimalzahl',
    noDocuments: 'Keine geschützten Rezepturdokumente vorhanden.',
    notUsed: 'Keine Verwendung gefunden.',
  },
  messages: {
    saved: 'Rezepturversion gespeichert.',
    invalid: 'Bitte korrigiere die ungültigen Rezepturdaten.',
    submitted: 'Rezeptur zur unabhängigen Prüfung eingereicht.',
    workflowUpdated: 'Rezepturworkflow aktualisiert.',
  },
  tabs: {
    editor: 'Editor',
    history: 'Versionen und Vergleich',
    impact: 'Verwendung / Impact',
    processRouting: 'Prozess / Arbeitsplan',
    documents: 'DMS-Dokumente',
  },
  alternatives: {
    title: 'Alternative Komponenten und freigegebene Substitutionen',
    empty: 'Für diese Position ist keine Alternative definiert.',
  },
  actionDialog: {
    REVIEW: {
      title: 'Fachprüfung abschließen',
      description: 'Bestätige die unabhängige Prüfung mit einem nachvollziehbaren Vermerk.',
    },
    APPROVE: {
      title: 'Rezepturversion freigeben',
      description: 'Die Freigabe friert diese Version ein und erfordert das Vier-Augen-Prinzip.',
    },
    COPY: {
      title: 'In neue Version kopieren',
      description:
        'Ein neuer bearbeitbarer Entwurf entsteht; Substitutionsentscheidungen werden erneut geprüft.',
    },
    BLOCK: {
      title: 'Rezepturversion sperren',
      description:
        'Die freigegebene oder geprüfte Version bleibt unveränderlich, darf aber nicht mehr verwendet werden.',
    },
    ARCHIVE: {
      title: 'Rezepturversion archivieren',
      description:
        'Die Version bleibt vollständig nachvollziehbar und wird aus der aktiven Nutzung genommen.',
    },
    SUB_APPROVE: {
      title: 'Substitution freigeben',
      description:
        'Bestätige die technische Gleichwertigkeit unabhängig und dokumentiere den Nachweis.',
    },
    SUB_REJECT: {
      title: 'Substitution ablehnen',
      description:
        'Dokumentiere, weshalb die vorgeschlagene Alternative nicht verwendet werden darf.',
    },
  },
  compare: {
    title: 'Rezepturversionen vergleichen',
    description:
      'Kopf- und Positionsunterschiede werden aus unveränderlichen Versionssnapshots ermittelt.',
    headerChanges: 'Änderungen am Kopf',
    none: 'Keine Kopfänderungen.',
    added: 'Hinzugefügte Positionen',
    removed: 'Entfernte Positionen',
    changed: 'Geänderte Positionen',
  },
  compareFields: {
    name: 'Bezeichnung',
    baseQuantity: 'Referenzmenge',
    baseUnitCode: 'Basiseinheit',
    validFrom: 'Gültig ab',
    validTo: 'Gültig bis',
    comments: 'Kommentare',
    dmsAttachmentIds: 'DMS-Dokumentensnapshot',
    costCurrency: 'Kostenwährung',
    internalMaterialCost: 'Materialkosten',
    translations: 'Übersetzungen',
  },
} as const;
